// removed by extract-text-webpack-plugin
module.exports = {"people":"client-containers-RSVPParty-styles__people___3XjhR","person":"client-containers-RSVPParty-styles__person___opd_0","attending":"client-containers-RSVPParty-styles__attending___cQMbW","activities":"client-containers-RSVPParty-styles__activities___3tHAL","save":"client-containers-RSVPParty-styles__save___3Llxp"};


//////////////////
// WEBPACK FOOTER
// ./client/containers/RSVPParty/styles.css
// module id = 408
// module chunks = 0